import { Stamp } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { eur } from "@/lib/pricing";

export const FixedFeeRow = ({ q, update }) => {
  const on = !!q.fixed_fee_on;
  return (
    <section className={`bg-slate-900 border border-slate-800 rounded-lg p-4 grid grid-cols-2 sm:grid-cols-[1fr_auto_auto] gap-3 items-center transition-opacity ${on ? "" : "opacity-60"}`} data-testid="fixed-fee-row">
      <label className="col-span-2 sm:col-span-1 flex items-center gap-3 cursor-pointer">
        <Switch checked={on} onCheckedChange={(v) => update({ fixed_fee_on: v })} data-testid="fixed-fee-toggle" />
        <Stamp className="h-5 w-5 text-amber-400 shrink-0" />
        <span className="font-medium">Diritto fisso</span>
        {!on && <span className="text-xs text-slate-500" data-testid="fixed-fee-off-label">non applicato</span>}
      </label>
      <div className="flex items-center gap-2 text-sm text-slate-400">
        <Input type="number" min={0} step="1" value={q.fixed_fee ?? 0} disabled={!on} aria-label="Importo diritto fisso"
          onChange={(e) => update({ fixed_fee: Math.max(+e.target.value || 0, 0) })} className="h-8 w-28 font-mono" data-testid="fixed-fee-input" />
        <span>€</span>
      </div>
      <span className="text-right font-mono" data-testid="fixed-fee-amount">{eur(on ? +q.fixed_fee || 0 : 0)}</span>
    </section>
  );
};
